module.exports = "/android-selectedbc6a274d4e20e6d1247f309ffa7ba503.svg";